var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "common-icon-container"
  }, [_c('img', {
    staticClass: "common-icon",
    style: {
      width: _vm.props.width,
      height: _vm.props.height
    },
    attrs: {
      "src": _vm.props.src
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }